import {Button, Col, Container, Form, FormControl, InputGroup, Row} from 'react-bootstrap';
import React, {useState} from 'react';
import {ManifestDto} from '../api/rest/template/ManifestDto';
import ApiClientFactory from '../api/rest/template/TemplatesApiClientFactory';
import {TemplateDto} from '../TemplateDto';
import {useNavigate} from 'react-router-dom';
import {FaSearch} from 'react-icons/fa';

export default function HomePage() {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [template, setTemplate] = useState<TemplateDto>();

    const handleGenerateClicked = (manifest: ManifestDto) => {
        let templatesApiClient = ApiClientFactory.getTemplatesApiClient();
        templatesApiClient.getTemplateSchema('solidify', manifest.name).then((schemaResponse) => {
            templatesApiClient.getTemplateDefaults('solidify', manifest.name).then((defaultsResponse) => {
                setTemplate({
                    manifest: manifest,
                    schema: schemaResponse,
                    defaults: defaultsResponse,
                });
            });
        });
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // zapobiega domyślnej akcji submit formularza
            navigate(`/search?q=${encodeURIComponent(query)}`);
        }
    };

    return (
        <Container fluid className={'mt-5 pt-4'}>
            <Row>
                <Col sm={12} className={'text-center'}>
                    <h1 className="display-4 mb-4">Component Templates</h1>
                    <div className={'lead mb-5'}>
                        Discover and use pre-built components for your projects. Each component is carefully crafted with
                        accessibility, performance, and reusability in mind.
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={3}></Col>
                <Col sm={6}>
                    <Form className="d-flex ms-3" onSubmit={(e) => e.preventDefault()}>
                        <InputGroup>
                            <FormControl
                                type="search"
                                placeholder="springboot, react, picocli, ..."
                                className="fs-3 mt-4 p-3"
                                aria-label="Search"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                onKeyUp={handleKeyPress}
                            />
                        </InputGroup>
                    </Form>
                </Col>
                <Col sm={3}></Col>
            </Row>
        </Container>
    );
}
